import { hasV2Basket } from "../basket-v2";
import { EventBasketType } from "./EventBasketType";

const basketExpectations = new Map<EventBasketType, () => Promise<boolean>>();
basketExpectations.set("v2", () => hasV2Basket());

export async function checkBasketExists(): Promise<EventBasketType | undefined> {
  for (const [type, expectation] of basketExpectations.entries()) {
    const exists = await expectation();
    if (exists) {
      return type;
    }
  }

  return undefined;
}
